import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Pen: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size + 1}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.228 0l3.049 3.048-8.562 8.562H.667V8.56L9.228 0zM7.614 3.5L2 9.114v1.162h1.163l5.613-5.614L7.614 3.5zm1.614-1.614l-.671.67L9.72 3.72l.67-.67-1.162-1.163z"
        fill={color}
      />
    </svg>
  );
};

export default Pen;
